/* eslint-disable max-len */
import * as React from 'react'
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" {...props}>
    <g fill="#000" fillRule="nonzero">
      <path d="M14.857 7.946a1.92 1.92 0 0 0-1.364.57c-.361.365-.564.86-.564 1.376v28.216c0 1.075.863 1.946 1.928 1.946h19.286a1.937 1.937 0 0 0 1.928-1.946V9.892a1.937 1.937 0 0 0-1.928-1.946H14.857Zm0-1.946h19.286C36.273 6 38 7.742 38 9.892v28.216C38 40.258 36.273 42 34.143 42H14.857C12.727 42 11 40.258 11 38.108V9.892C11 7.742 12.727 6 14.857 6Z" />
      <path d="M20 10h9c1 0 1.5.5 1.5 1.5S30 13 29 13h-9c-1 0-1.5-.5-1.5-1.5S19 10 20 10ZM24.5 33c1.667 0 2.5.833 2.5 2.5s-.833 2.5-2.5 2.5-2.5-.833-2.5-2.5.833-2.5 2.5-2.5Z" />
    </g>
  </svg>
)
export default SvgComponent
